import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { UserData } from "@/entities/User";

import { fetchProfile } from "../services/fetchProfile";
import { logout } from "../services/logout";
import { updateProfile } from "../services/updateProfile";
import { AuthSchema } from "../types/authSchema";

const initialState: AuthSchema = {};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsReady: (state, action: PayloadAction<boolean>) => {
      state.isReady = action.payload;
    },
    setUserData: (state, action: PayloadAction<UserData>) => {
      state.userData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.fulfilled, (state, action: PayloadAction<UserData>) => {
        state.isReady = true;
        state.userData = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        if (action.payload.code === "ERR_CANCELED") {
          return;
        }
        state.isReady = true;
      });

    builder
      .addCase(logout.fulfilled, (state) => {
        state.userData = undefined;
      })
      .addCase(logout.rejected, (state) => {
        state.userData = undefined;
      })
      .addCase(updateProfile.fulfilled, (state, action: PayloadAction<UserData>) => {
        state.userData = action.payload;
      });
  },
});

export const { actions: authActions } = authSlice;
export const { reducer: authReducer } = authSlice;
